var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-find"},[_c('p',[_vm._v("没有找到对应的页面")]),_c('el-button',{staticClass:"return-btn",attrs:{"type":"primary"},on:{"click":_vm.returnIndex}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }